<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách CTA</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">Dashboard</a></li>
              <li class="breadcrumb-item active">Danh sách CTA</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_cta_modal"
              ><i class="fa fa-plus"></i> Thêm CTA</a
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div>
            <table class="table table-striped custom-table mb-0">
              <thead>
                <tr>
                  <th>Tên CTA</th>
                  <th>Nội dung CTA</th>
                  <th class="text-right">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cta in ctas" :key="cta.id">
                  <td>{{ cta.name }}</td>
                  <td v-html="cta.ctaContent"></td>
                  <td class="text-right">
                    <div class="dropdown dropdown-action">
                      <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          href="#"
                          data-toggle="modal"
                          data-target="#edit_cta_modal"
                          @click="editCta(cta)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          href="#"
                          data-toggle="modal"
                          data-target="#delete_cta_modal"
                          @click="confirmDelete(cta.id)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="ctas.length === 0 && !loading">
                  <td colspan="3" class="text-center">Không tìm thấy CTA nào.</td>
                </tr>
                <tr v-if="loading">
                  <td colspan="3" class="text-center">Đang tải...</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            Hiển thị {{ currentPage * pageSize + 1 }} đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }} của {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 0 }">
                <a href="#" class="page-link" @click.prevent="goToPage(currentPage - 1)">Previous</a>
              </li>
              <li
                class="paginate_button page-item"
                :class="{ active: pageNum === currentPage + 1 }"
                v-for="pageNum in totalPages"
                :key="pageNum"
              >
                <a href="#" class="page-link" @click.prevent="goToPage(pageNum - 1)">{{ pageNum }}</a>
              </li>
              <li
                class="paginate_button page-item next"
                :class="{ disabled: currentPage === totalPages - 1 }"
              >
                <a href="#" class="page-link" @click.prevent="goToPage(currentPage + 1)">Next</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div id="add_cta_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Thêm CTA</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeBootstrapModal('add_cta_modal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addCta">
              <div class="form-group">
                <label>Tên CTA <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="newCta.name" required />
              </div>
              <div class="form-group">
                <label>Nội dung CTA <span class="text-danger">*</span></label>
                <Editor
                  v-model="newCta.ctaContent"
                  api-key="yrhpcam8qdug0kvk57vkx6kqcvs0qik1uatwa80yhh12nk1x"
                  :init="tinyInit"
                />
              </div>
              <div class="submit-section">
                <button type="submit" class="btn btn-primary submit-btn" :disabled="isAdding">
                  <span v-if="isAdding" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-else>Thêm</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div id="edit_cta_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sửa CTA</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeBootstrapModal('edit_cta_modal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateCta">
              <div class="form-group">
                <label>Tên CTA <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="currentCta.name" required />
              </div>
              <div class="form-group">
                <label>Nội dung CTA <span class="text-danger">*</span></label>
                <Editor
                  v-model="currentCta.ctaContent"
                  api-key="yrhpcam8qdug0kvk57vkx6kqcvs0qik1uatwa80yhh12nk1x"
                  :init="tinyInit"
                />
              </div>
              <div class="submit-section">
                <button type="submit" class="btn btn-primary submit-btn" :disabled="isUpdating">
                  <span v-if="isUpdating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-else>Lưu thay đổi</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal custom-modal fade" id="delete_cta_modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Xóa CTA</h3>
              <p>Bạn có chắc chắn muốn xóa CTA này không?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteCta" :disabled="isDeleting"
                    >
                    <span v-if="isDeleting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else>Xóa</span>
                  </a>
                </div>
                <div class="col-6">
                  <a href="javascript:void(0);" class="btn btn-primary cancel-btn" data-dismiss="modal"
                    >Hủy</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <FileManagerModal 
      v-if="showFileManagerModal" 
      :folderTabs="imageTabs"
      @close="showFileManagerModal = false"
      @file-selected="onFileSelected"
      @tab-created="onTabCreated"
      @tab-deleted="onTabDeleted"
    />
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from 'vue';
import api from '../api';
import { useToast } from 'vue-toastification';
import Editor from '@tinymce/tinymce-vue';
import FileManagerModal from '@/components/FileManagerModal.vue';

// --- Khởi tạo Toast ---
const toast = useToast();

// --- Data (State) ---
const ctas = ref([]);
const loading = ref(true);

const newCta = reactive({
  name: '',
  ctaContent: '',
});

const currentCta = reactive({
  id: null,
  name: '',
  ctaContent: '',
});

const ctaToDeleteId = ref(null);

// --- Pagination State ---
const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

// --- Loading states for buttons ---
const isAdding = ref(false);
const isUpdating = ref(false);
const isDeleting = ref(false);

// --- File Manager Modal State ---
const showFileManagerModal = ref(false);
const fileManagerCallback = ref(null);
const imageTabs = ref([]); // Sẽ được lấy từ API
const targetField = ref(null);

// --- Functions (Methods) ---

/**
 * Tải danh sách các CTA từ API với phân trang.
 */
const fetchCtas = async () => {
  loading.value = true;
  try {
    const response = await api.get('/api/ctas', {
      params: {
        page: currentPage.value,
        size: pageSize.value,
      },
    });
    const data = response.data;
    ctas.value = Array.isArray(data.content) ? data.content : [];
    totalElements.value = typeof data.totalElements === 'number' ? data.totalElements : 0;
    totalPages.value = typeof data.totalPages === 'number' ? data.totalPages : 0;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Không thể tải danh sách CTA. Vui lòng thử lại hoặc kiểm tra kết nối.';
    toast.error(errorMessage);
    ctas.value = [];
    totalElements.value = 0;
    totalPages.value = 0;
  } finally {
    loading.value = false;
  }
};

/**
 * Lấy danh sách folder từ server
 */
const fetchFolders = async () => {
  try {
    const res = await api.get('/api/images/folders');
    if (res.data) {
      imageTabs.value = res.data.map((folderName, index) => ({
        id: (index + 1).toString(),
        name: folderName,
        folderName: folderName,
      }));
    }
  } catch (err) {
    console.error('Lỗi khi lấy danh sách folder:', err);
    imageTabs.value = [];
    toast.error('Lỗi khi tải danh sách folder.');
  }
};

/**
 * Xử lý khi người dùng tạo tab folder mới trong modal.
 */
const onTabCreated = (newTab) => {
  imageTabs.value.push(newTab);
};

/**
 * Xử lý khi người dùng xóa tab folder trong modal.
 */
const onTabDeleted = (tabIdToDelete) => {
  imageTabs.value = imageTabs.value.filter(tab => tab.id !== tabIdToDelete);
};

/**
 * Xử lý khi người dùng chọn một file từ modal
 * @param {Object} image - Đối tượng chứa thông tin ảnh đã chọn
 */
const onFileSelected = (image) => {
  if (targetField.value === 'content' && fileManagerCallback.value) {
    if (image && image.url) {
      fileManagerCallback.value(image.url, { alt: image.title, title: image.title });
    } else {
      console.error('Lỗi: Đối tượng ảnh không có trường url hợp lệ.');
    }
  }
  showFileManagerModal.value = false;
  fileManagerCallback.value = null;
  targetField.value = null;
};

// --- TinyMCE Init với file_picker_callback đã được cập nhật ---
const tinyInit = {
  height: 200,
  menubar: false,
  plugins: [
    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor',
    'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'paste', 'help', 'wordcount'
  ],
  toolbar: [
    'undo redo | blocks fontfamily fontsize | bold italic underline forecolor backcolor',
    'alignleft aligncenter alignright alignjustify | bullist numlist | link image media | code fullscreen'
  ],
  relative_urls: false,
  remove_script_host: false,
  document_base_url: window.location.origin + '/',
  toolbar_mode: 'floating',
  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
  
  // Cập nhật file_picker_callback để gọi fetchFolders và mở modal
  file_picker_callback: async (cb, value, meta) => {
    if (meta.filetype === 'image') {
      targetField.value = 'content';
      fileManagerCallback.value = cb;
      await fetchFolders(); // Lấy danh sách folder trước khi mở modal
      showFileManagerModal.value = true;
    }
  },
};

/**
 * Chuyển trang trong danh sách CTA.
 * @param {number} page - Số trang muốn đến (dựa trên 0).
 */
const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchCtas();
  }
};

/**
 * Hàm trợ giúp để đóng modal Bootstrap 4 (hoặc tương thích) bằng jQuery.
 * @param {string} modalId - ID của modal cần đóng.
 */
const closeBootstrapModal = (modalId) => {
  // ... (giữ nguyên logic đóng modal cũ)
  const modalElement = document.getElementById(modalId);
  if (modalElement) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.modal !== 'undefined') {
      jQuery(`#${modalId}`).modal('hide');
    } else {
      const dismissButton = modalElement.querySelector('[data-dismiss="modal"]');
      if (dismissButton) {
          dismissButton.click();
      } else {
          toast.error(`Lỗi: Không thể đóng modal #${modalId}. Vui lòng đảm bảo jQuery và Bootstrap JS được tải đúng cách.`, {
              timeout: 3000
          });
      }
    }
  } else {
    toast.error(`Lỗi: Không tìm thấy modal #${modalId}.`, {
        timeout: 3000
    });
  }
};


/**
 * Thêm một CTA mới.
 */
const addCta = async () => {
  // ... (giữ nguyên logic thêm CTA)
  if (!newCta.name.trim() || !newCta.ctaContent.trim()) {
    toast.warning('Vui lòng nhập đầy đủ thông tin CTA.');
    return;
  }

  isAdding.value = true;
  try {
    await api.post('/api/ctas', newCta);
    toast.success('Thêm CTA thành công!');
    closeBootstrapModal('add_cta_modal');
    resetNewCtaForm();
    await fetchCtas();
  } catch (error) {
    let errorMessage = 'Có lỗi xảy ra khi thêm CTA.';
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.request) {
      errorMessage = 'Không nhận được phản hồi từ máy chủ. Vui lòng kiểm tra kết nối mạng của bạn.';
    }
    toast.error(errorMessage);
  } finally {
    isAdding.value = false;
  }
};


/**
 * Chuẩn bị dữ liệu cho form sửa CTA.
 * @param {Object} cta - Đối tượng CTA cần chỉnh sửa.
 */
const editCta = (cta) => {
  Object.assign(currentCta, { ...cta });
};

/**
 * Cập nhật thông tin CTA hiện tại.
 */
const updateCta = async () => {
  // ... (giữ nguyên logic cập nhật CTA)
  if (!currentCta.id) {
    toast.error('Không xác định được CTA cần cập nhật.');
    return;
  }

  if (!currentCta.name.trim() || !currentCta.ctaContent.trim()) {
    toast.warning('Vui lòng nhập đầy đủ thông tin trước khi lưu.');
    return;
  }

  isUpdating.value = true;
  try {
    await api.put(`/api/ctas/${currentCta.id}`, currentCta);
    toast.success('Cập nhật CTA thành công!');
    closeBootstrapModal('edit_cta_modal');
    Object.assign(currentCta, { id: null, name: '', ctaContent: '' });
    await fetchCtas();
  } catch (error) {
    let errorMessage = 'Có lỗi xảy ra khi cập nhật CTA.';
    if (error.response?.status === 404) {
      errorMessage = 'Không tìm thấy CTA để cập nhật. Có thể nó đã bị xóa.';
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.request) {
      errorMessage = 'Không nhận được phản hồi từ máy chủ. Vui lòng kiểm tra kết nối mạng của bạn.';
    }
    toast.error(errorMessage);
  } finally {
    isUpdating.value = false;
  }
};


/**
 * Lưu ID của CTA cần xóa để xác nhận trong modal.
 * @param {number} id - ID của CTA cần xóa.
 */
const confirmDelete = (id) => {
  ctaToDeleteId.value = id;
};

/**
 * Xóa CTA đã chọn.
 */
const deleteCta = async () => {
  // ... (giữ nguyên logic xóa CTA)
  if (!ctaToDeleteId.value) {
    toast.error('Không xác định được CTA cần xóa.');
    return;
  }

  isDeleting.value = true;
  try {
    await api.delete(`/api/ctas/${ctaToDeleteId.value}`);
    toast.success('Xóa CTA thành công!');
    closeBootstrapModal('delete_cta_modal');
    await fetchCtas();
  } catch (error) {
    let errorMessage = 'Có lỗi xảy ra khi xóa CTA.';
    if (error.response?.status === 404) {
      errorMessage = 'CTA đã bị xóa hoặc không tồn tại.';
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.request) {
      errorMessage = 'Không nhận được phản hồi từ máy chủ. Vui lòng kiểm tra kết nối mạng của bạn.';
    }
    toast.error(errorMessage);
  } finally {
    isDeleting.value = false;
    ctaToDeleteId.value = null;
  }
};


/**
 * Đặt lại các trường trong form thêm CTA về giá trị ban đầu.
 */
const resetNewCtaForm = () => {
  newCta.name = '';
  newCta.ctaContent = '';
};

// Gọi hàm fetchCtas() khi component được mount
onMounted(() => {
  fetchCtas();
});
</script>

<style>
/* Bạn có thể thêm các CSS tùy chỉnh ở đây nếu cần */
/* Ví dụ cho spinner */
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}
</style>